<template>
  <div class="h-100 d-flex flex-column">
    <!-- https://www.primefaces.org/primevue/showcase-v2/#/datatable -->
    <div class="row f-row h-100 justify-content-center">
      <div
        class="col col-12 text-center justify-content-center"
        style="width:100%; padding: 0 5px 0 5px;
        height: calc(100vh - 128px)!important;"
      >
        <DataTable
          :alwaysShowPaginator="true"
          :filters.sync="filters"
          :loading="showLoading"
          :paginator="true"
          :rowHover="true"
          :rows="15"
          :rowsPerPageOptions="[10, 15, 20, 25, 30, 50, 100, 1000]"
          :scrollable="true"
          :selection.sync="selectedExposures"
          :value="dataVar"
          :virtual="true"
          ref="dt"
          class="p-datatable-sm editable-cells-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          editMode="cell"
          :filterDisplay="showFilters ? 'menu' : ''"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          responsiveLayout="scroll"
          stickyHeader="true"
        >
          <template #header>
            <div
              class="flex justify-content-between align-items-center"
              style="background: var(--lightbackground3)!important;"
            >
              <table
                class="table table-sm table-borderless"
                style="padding: 0 5px 0 5px;"
              >
                <tbody>
                  <tr>
                    <td style="width: 10%" class="txt-label-primary">
                      <span class="p-input-icon-left">
                        <i
                          class="pi pi-search"
                          style="font-size: 0.75rem!important;"
                        />
                        <InputText
                          style="font-size: 0.75rem!important;"
                          v-model="filters['global'].value"
                          placeholder="Keyword Search"
                        />
                      </span>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%; padding-top: 5px!important;"
                    >
                      <ToggleButton
                        :id="'fields'"
                        :defaultState="false"
                        :labelEnableText="'- Fields'"
                        :labelDisableText="'+ Fields'"
                        v-on:change="showAllFields = !showAllFields"
                      />
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Download:
                      <button
                        v-on:click="download"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Add:
                      <button
                        v-on:click="onClientCreate"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ saveLegend }}
                      <button
                        v-on:click="onClientSaveToDB"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-save" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ refreshLegend }}
                      <button
                        v-on:click="onClientDiscard"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Delete:
                      <button
                        v-on:click="deleteFromDB"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template #empty>
            No exposures found.
          </template>
          <template #loading>
            Loading exposures. Please wait.
          </template>

          <Column
            field="actions"
            header="Actions"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              <i
                class="fa fa-exclamation program"
                aria-hidden="true"
                v-show="data.edited"
              ></i>
              <button
                v-on:click="onEditItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onCopyItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-copy" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onDeleteItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </template>
          </Column>

          <Column
            field="custom_id"
            header="ID"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.custom_id }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by id"
              />
            </template>
          </Column>

          <Column
            field="custom_name"
            header="Contract"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.custom_name }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by contract"
              />
            </template>
          </Column>

          <Column
            header="Portfolio"
            sortable
            filterField="fk_idportafolio"
            sortField="fk_idportafolio"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idportafolio }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Portfolio Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="portfoliosDDown"
                placeholder="Select Portfolio"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Rate"
            sortable
            filterField="fk_idcurrency"
            sortField="fk_idcurrency"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcurrency }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Rate Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="currenciesDDown"
                placeholder="Select Rate"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Exposure Type"
            sortable
            filterField="fk_idexposureoption"
            sortField="fk_idexposureoption"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idexposureoption }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Exposure Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="expoTypeDDown"
                placeholder="Select Type"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            field="notional"
            header="Notional"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.notional | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Currency"
            sortable
            filterField="fk_idcountry_currency"
            sortField="fk_idcountry_currency"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcountry_currency }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Currency Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="notionalCurrencyDDown"
                placeholder="Select Currency"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            field="planned_expiration_date"
            header="Expected Cash Flow Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.planned_expiration_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="issue_date"
            header="Issue Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.issue_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="rate_at_issue_date"
            header="Rate at Issue Date"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.rate_at_issue_date | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="expiration_date"
            header="Invoice Due Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.expiration_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="auto3"
            header="Freight"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.auto3 | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="insurance"
            header="Insurance"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.insurance | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="tariffs"
            header="Tariffs"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.tariffs | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="request_number"
            header="Request Number"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.request_number }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by request number"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="purchase_order"
            header="Purchose Order"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.purchase_order }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by purchase order"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="loading_date"
            header="Loading Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.loading_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="shipping_date"
            header="Shipping Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.shipping_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="eta"
            header="Delivery Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.eta | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="fk_id_business"
            header="Business"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_business }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by business"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Country of Origin"
            sortable
            filterField="country_origin_name"
            sortField="country_origin_name"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.country_origin_name }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Country Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="countryOriginDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Destination Country"
            sortable
            filterField="country_name"
            sortField="country_name"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '9rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.country_name }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Country Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="countryDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="provider"
            header="Supplier"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.provider }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by supplier"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="client"
            header="Client"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.client }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by client"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Plant"
            sortable
            filterField="plant"
            sortField="plant"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.plant }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Plant Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="plantDDown"
                placeholder="Select Plant"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Port"
            sortable
            filterField="port"
            sortField="port"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.port }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Port Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="portDDown"
                placeholder="Select port"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="rate_at_realized_expiration_date"
            header="Settlement Rate"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.rate_at_realized_expiration_date | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="comments"
            header="Comments"
            sortable
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.comments }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by comments"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <!-- Loading Modal -->
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { gatewayService } from "@/_services/gateway.service";
import { Company } from "@/_core/data/Company";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { timeFormat, format } from "d3";
import Calendar from "primevue/calendar";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Messages from "../modals/Messages.vue";
import MultiSelect from "primevue/multiselect";
import ToggleButton from "@/components/ToggleButton.vue";
import { createDataModelTable } from "@/_core/data/SaveToDB";

export default {
  name: "DataTableExpo",
  components: {
    Calendar,
    Column,
    DataTable,
    InputNumber,
    InputText,
    Messages,
    MultiSelect,
    ToggleButton,
  },
  props: {
    dataSaved: { required: true },
    dataVar: { required: true },
    headersToExport: { required: true },
    list_file: { required: true },
    processData: { required: true },
    refreshLegend: { required: true },
    saveLegend: { required: true },
    selectedCompany: { required: true },
    selectedList: { required: true },
    selectedNAsset: { required: true },
    selectedPortfolios: { required: true },
    showLoading: { required: true },
  },
  data() {
    return {
      companies: [],
      dataToExport: [],
      selection: "fx_expo",
      filters: {
        pk: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_idportafolio: { value: null, matchMode: FilterMatchMode.IN },
        fk_idcurrency: { value: null, matchMode: FilterMatchMode.IN },
        fk_idexposureoption: { value: null, matchMode: FilterMatchMode.IN },
        planned_expiration_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        notional: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        fk_idcountry_currency: { value: null, matchMode: FilterMatchMode.IN },
        issue_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        rate_at_issue_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        expiration_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        hedged_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        sale_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        shipping_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        hedge_asset: { value: null, matchMode: FilterMatchMode.IN },
        end_product: { value: null, matchMode: FilterMatchMode.IN },
        custom_name: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        custom_id: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        provider: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        client: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        loading_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        eta: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        fk_id_end_product: { value: null, matchMode: FilterMatchMode.IN },
        plant: { value: null, matchMode: FilterMatchMode.IN },
        port: { value: null, matchMode: FilterMatchMode.IN },
        ratio: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        budget_futures: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        budget_price: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        auto3: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        request_number: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        purchase_order: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_id_business: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        country_origin_name: { value: null, matchMode: FilterMatchMode.IN },
        country_name: { value: null, matchMode: FilterMatchMode.IN },
        insurance: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        tariffs: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        comments: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        rate_at_realized_expiration_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        settlement_pnl: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },

        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      selectedExposures: null,
      sheetTransaction: null,
      showFilters: true,
      showAllFields: false,
      showMore: "+ Fields",
      user: [],
    };
  },
  computed: {
    portfoliosDDown() {
      return this.dataVar
        .map((d) => d.fk_idportafolio)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    currenciesDDown() {
      return this.dataVar
        .map((d) => d.fk_idcurrency)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    expoTypeDDown() {
      return this.dataVar
        .map((d) => d.fk_idexposureoption)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    notionalCurrencyDDown() {
      return this.dataVar
        .map((d) => d.fk_idcountry_currency)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null);
    },
    hedgedAssetDDown() {
      return this.dataVar
        .map((d) => d.hedge_asset)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    endProductDDown() {
      return this.dataVar
        .map((d) => d.end_product)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    plantDDown() {
      return this.dataVar
        .map((d) => d.plant)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    portDDown() {
      return this.dataVar
        .map((d) => d.port)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    countryDDown() {
      return this.dataVar
        .map((d) => d.country_name)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    countryOriginDDown() {
      return this.dataVar
        .map((d) => d.country_origin_name)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
  },
  created() {
    try {
      this.sheetTransaction = new SheetsTransaction(
        this.dataToExport,
        this.headersToExport,
      );
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.log(`Error companies loader ${error}`);
    }
  },
  methods: {
    // ====================== Emit variables ======================
    onClientCreate() {
      this.$emit("eventOnClientCreate");
    },
    onEditItem(item) {
      this.$emit("eventOnEditItem", item);
    },
    onDeleteItem(item) {
      this.$emit("eventOnDeleteItem", item);
    },
    onCopyItem(item) {
      this.$emit("eventOnCopyItem", item);
    },
    onClientSaveToDB() {
      this.$emit("eventOnClientSaveToDB");
    },
    onClientDiscard() {
      this.$emit("eventOnClientDiscard");
    },
    onAfterDelete() {
      this.$emit("eventOnAfterDelete");
    },
    onAfterDeleteCompany() {
      this.$emit("eventOnAfterDeleteCompany");
    },

    // ====================== DB related ======================
    deleteFromDB() {
      var r = confirm(
        "Are you sure you want to delete this table (exposure/hedges)?",
      );
      if (r === true) {
        let deleteTable = null;
        let getPortfolioNumber = [];
        let vis = this;
        this.companies = this.$store.state.companies.all.items;
        vis.selectedPortfolios.forEach(function(selectedPortfolio) {
          getPortfolioNumber.push(
            vis.companies[vis.selectedCompany].portfolios[selectedPortfolio.id]
              .pk_idportfolio,
          );
        });
        if (this.selectedList === 0 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteExposure;
        }
        if (this.selectedList === 0 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteExposure;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteHedge;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteHedge;
        }
        let payload = {
          format: "json",
          selected_company: this.companies[this.selectedCompany].pk_idcompany,
          user_id: this.user.pk_idusers,
          selection: this.selectedList,
          selected_porfolios: { id_portfolios: getPortfolioNumber },
        };
        this.modal_processing_message.showModalLoading = !this
          .modal_processing_message.showModalLoading;
        this.modal_processing_message.messageModal = "Deleting....";
        var delay_state = this;
        deleteTable(payload)
          .then((data) => {
            this.processed_company.onLoadData();
            setTimeout(function() {
              delay_state.modal_processing_message.showModalLoading = !delay_state
                .modal_processing_message.showModalLoading;
              delay_state.modal_process_finished_message.showModalLoading = !delay_state
                .modal_process_finished_message.showModalLoading;
              delay_state.modal_process_finished_message.optionsModal = true;
              delay_state.modal_process_finished_message.messageModal =
                data["successful"];
              delay_state.onAfterDeleteCompany();
              delay_state.onAfterDelete();
            }, 10000);
          })
          .catch((error) => {
            this.modal_processing_message.showModalLoading = !this
              .modal_processing_message.showModalLoading;
            this.modal_process_finished_message.showModalLoading = !this
              .modal_process_finished_message.showModalLoading;
            this.modal_process_finished_message.optionsModal = true;
            this.modal_process_finished_message.messageModal =
              "An error has occurred" + error;
          });
      }
    },
    download() {
      createDataModelTable(this);
    },
  },
  filters: {
    numberFormat: function(val) {
      return !val ? "-" : format(",")(val);
    },
    dateFormat: function(val) {
      return !val || +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
  },
};
</script>
